namespace $ {
	const { rem, em, px, per } = $mol_style_unit
	const { hsla } = $mol_style_func

	const border_width = px(1)
	$mol_style_define($exso_sheets_dashboard, {
		$mol_view: {
			'@': {
				progress_type: Object.fromEntries(
					Object.entries({
						medium: 'orange',
						high: 'limegreen',
						low: 'red',
					}).map(([k, v]) => [k, { '--color': v }]),
				),
			},
		},
		Logo: { flex: { grow: 1 } },

		Cards: {
			alignItems: 'center',
		},
		Card: {
			whiteSpace: 'nowrap',
			gap: $mol_gap.space,
			$mol_icon: {
				alignSelf: 'end',
				width: rem(2),
				height: rem(2),
				color: $mol_theme.shade,
			},
		},
		Card_value: {
			fontSize: rem(2),
			fontWeight: 'bold',
		},

		Sites_list: {
			paddingInline: '0',
			'@media': {
				'(width >= 1280px)': {
					display: 'grid',
					gridTemplateColumns: 'repeat(2, 1fr)',
				},
			},
		},

		Site: {
			background: { color: $mol_theme.line },
			padding: 0,
			flex: { grow: 1 },
			overflow: 'hidden',
			border: {
				width: border_width,
				style: 'solid',
				color: $mol_theme.line,
				radius: $mol_gap.block,
			},
			color: 'inherit',
			transition: '0.25s all',
			':hover': { background: { color: $mol_theme.current } },
		},
		Site_title: {
			padding: 0,
			flex: { grow: 1 },
		},
		Site_name: {
			font: { weight: 'bold', size: em(1.3) },
		},
		Site_head: {
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			margin: { bottom: border_width },
			alignItems: 'center',
		},
		Site_content: { flex: { grow: 1 } },
		Site_progresses: { padding: 0 },
		Site_progress: {
			font: { weight: 'bold' },
			width: 'fit-content',
			padding: [0, em(0.5)],
			gap: em(0.5),
			alignItems: 'center',
			border: { radius: '100vmax' },
			backgroundColor: 'color-mix(in srgb, currentColor 10%, transparent)',
			fontSize: rem(1.1),
			color: $mol_style_func.vary('--color'),
		},
		Site_stat: {
			flex: { basis: rem(10), grow: 1 },
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			position: 'relative',
			'@': {
				stat_type: {
					main: {
						flex: { basis: per(100) },
					},
				},
			},
			'@media': {
				'(width >= 500px)': {
					'@': {
						stat_type: {
							main: {
								flex: { basis: per(49) },
							},
						},
					},
				},
			},
		},
		Site_stats: {
			padding: 0,
			gap: border_width,
			alignItems: 'stretch',
		},
		Site_stat_title: {
			gap: $mol_gap.space,
			fontSize: em(1.05),
			$mol_icon: { color: $mol_style_func.vary('--color', 'var(--mol_theme_shade)') },
		},
		Site_stat_item: {
			font: { weight: 'bold' },
		},
	})
	$mol_style_define($exso_sheets_dashboard_row, {
		gap: $mol_gap.space,
		Label: {
			color: $mol_theme.shade,
			font: { weight: 'normal', size: rem(1) },
		},
	})
}
